module.exports = __webpack_public_path__ + "static/media/calendar-with-header-icon-177x197.6e216962.jpg";